import React from 'react'
import 'react-day-picker/lib/style.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import dateFnsFormat from 'date-fns/format';

import "./CalendarPicker.css";

// Disable dates in the past, and dates where sundries are not done.
const disabledDays = [
  {before: new Date()},
  {from: new Date(2022, 11, 12), to: new Date(2023, 0, 9)}
];

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale });
}

// FixMe: DayPickerInput complains about a "bad setState()" being called. Its working... but find what its issue is
function CalendarPicker({ parseDate, disabledDays }) {
  const FORMAT = "yyyy-MM-dd"



  // { from: new Date(2022, 11, 12), to: new Date(2022, 11, 19) }

  return (
    <div className="calendarPickerContainer">

      <DayPickerInput
        formatDate={formatDate}
        format={FORMAT}
        parseDate={parseDate}
        placeholder="Collection Date"
        dayPickerProps={{ disabledDays: disabledDays }}
        inputProps={{readOnly: true}}
      />

    </div>
  )
}

export default CalendarPicker
